export { default } from './ComArribar';
